module.exports = __webpack_public_path__ + "img/form.ddc0dce7.svg";